export enum ERoles {
  REF_ADMIN= 'Ref_Admin',
  REF_TECHNIQUE= 'Ref_Technique',
  REF_MISSION_RW= 'Ref_mission_RW',
  REF_UO_RW= 'Ref_UO_RW',
  REF_UO_RO= 'Ref_UO_RO'
}
